import { render, staticRenderFns } from "./EditDriver.vue?vue&type=template&id=0c51420c"
import script from "./EditDriver.vue?vue&type=script&lang=js"
export * from "./EditDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports